// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"8197e9a6","839":"e7325449"}[chunkId] + ".chunk.js";
};